if (!customElements.get('cart-property-validation')) {
  class CartPropertyValidation extends HTMLElement {
  constructor() {
      super();
      this.checkPrices();
    }
    
    checkPrices = async () => {
      
      const url = new URL(window.location.href);
      const params = url.searchParams;
      
      if (params.has('reloaded')) return;
      
      const data = await fetch('/cart.js');
      const cart = await data.json();
      let items = [];
      let isCardValid = true;
      const promises = [];

      for (const item of cart.items) {
        const productUrl = new URL(`${window.location.origin}${item.url}`);
        productUrl.searchParams.append('view', 'discount.json');
        promises.push(
          fetch(productUrl).then(r => r.json()).then(discountJson => {
            if (discountJson.discount != item.properties['_discount']) {
              isCardValid = false;
            }
          })
        )
      }
      
      await Promise.all(promises);
      
      if (!isCardValid) {
        new UpdateCartDiscounts();
      }
    } 
  }

  customElements.define('cart-property-validation', CartPropertyValidation);
}